import { useEffect, useLayoutEffect } from 'react'

// useLayoutEffect logs a warning when rendered on the server because there is
// no layout to flush to. Falling back to useEffect on the server silences the
// warning without changing client behaviour — server renders never run effects
// either way, and on the client useLayoutEffect still runs synchronously
// before paint.
export const useIsomorphicLayoutEffect =
  typeof window !== 'undefined' ? useLayoutEffect : useEffect
